import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4cf362ae"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "background"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "top-back"
};
const _hoisted_4 = {
  class: "icon-main"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 糖果择她 ");

const _hoisted_7 = {
  class: "mid-back"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "left-back"
};
const _hoisted_10 = ["src"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mid-title"
}, [/*#__PURE__*/_createTextVNode("交友约会、吃喝玩乐、实时距离，在这里找寻你心中的那个"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("她，与TA一起玩闹，与TA一起享受完美品质生活，向TA发"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("出邀请与TA一起完成一场完美的高品质约会。")], -1));

const _hoisted_12 = {
  class: "btn-back"
};
const _hoisted_13 = ["src"];

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Android下载");

const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "beian"
}, [/*#__PURE__*/_createTextVNode("网站备案/许可证号："), /*#__PURE__*/_createElementVNode("a", {
  class: "beian-link",
  href: "https://beian.miit.gov.cn"
}, "粤ICP备2022113931号-1"), /*#__PURE__*/_createTextVNode("   违法和不良信息举报邮箱：yry888yry@163.com")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_tip = _resolveComponent("contact-tip");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.quan,
    class: "icon"
  }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.tips.showTip && $setup.tips.showTip(...args))
  }, "联系我们")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $setup.rightimg,
    class: "rightimg"
  }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: $setup.word,
    class: "big-word"
  }, null, 8, _hoisted_10), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadAndroid && $setup.downloadAndroid(...args))
  }, [_createElementVNode("img", {
    src: $setup.android,
    class: "down-icon"
  }, null, 8, _hoisted_13), _hoisted_14]), _createElementVNode("div", {
    class: "qrback",
    onMouseleave: _cache[2] || (_cache[2] = (...args) => $setup.moved && $setup.moved(...args)),
    onMouseover: _cache[3] || (_cache[3] = (...args) => $setup.move && $setup.move(...args))
  }, [_withDirectives(_createElementVNode("img", {
    src: $setup.code,
    class: "small-code"
  }, null, 8, _hoisted_15), [[_vShow, !$setup.show]]), _withDirectives(_createElementVNode("img", {
    src: $setup.qrcode,
    class: _normalizeClass({
      'qrcode': true,
      'bigImg': $setup.big
    })
  }, null, 10, _hoisted_16), [[_vShow, $setup.show]])], 32)])])]), _hoisted_17]), _createVNode(_component_contact_tip, {
    ref: "tips"
  }, null, 512), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.bigImg && $setup.bigImg(...args))
  }, null, 512), [[_vShow, $setup.big]]), _withDirectives(_createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.bigImg && $setup.bigImg(...args)),
    class: "code-title"
  }, "扫描二维码下载", 512), [[_vShow, $setup.big]])]);
}